// extracted by css-extract-rspack-plugin
var _1 = "FFam71O7DRhHYYmpC4Bhug--";
var _2 = "VvS0oYeTp-VbhOpnmGf1cg--";
var _3 = "iS07OHtK-u0lq4isAV4s4w--";
export { _1 as "center", _2 as "narrow", _3 as "spacingTop" }
